import moment = require("moment");
import {Moment} from "moment";
import React = require("react");
import {ReactNode} from "react";
import {PeriodSelection} from "./PeriodChanger";
import "./TimeChanger.scss";

declare let LOCALE_MONTHS: string[];
declare let LOCALE_WEEK: string;

interface TimeChangerProps {
    period: PeriodSelection;
    onTimeSelection: (date: string) => void;
    startingDate: string;
    selectedDate: string;
}

interface SelectOption {
    value: string;
    label: string;
}

/**
 * Component that allow the user to move in time (between weeks, months).
 */
export class TimeChanger extends React.Component<TimeChangerProps, {}> {

    public static currentDate(period: PeriodSelection): string {
        const date: Moment = moment();
        switch (period) {
            case PeriodSelection.Week:
            case PeriodSelection.Rolling4Weeks:
                date.startOf("isoWeek");
                break;
            case PeriodSelection.Month:
            case PeriodSelection.RollingQuarter:
            case PeriodSelection.RollingSemester:
            case PeriodSelection.RollingYear:
                date.startOf("month");
                break;
            case PeriodSelection.Year:
                date.startOf("year");
                break;
            default:
                console.error("PeriodSelection " + period + " not recognized");
        }
        return TimeChanger.format(date);
    }

    public static format(date: Moment): string {
        return date.format("YYYY-MM-DD");
    }

    constructor(props: TimeChangerProps) {
        super(props);
    }

    public render(): ReactNode {
        const options: SelectOption[] = this.getSelectOptions();
        const onChange = (event) => {
            this.props.onTimeSelection(event.target.value);
        };
        return (
            <div className="marketing-tab__time-changer">
                <select
                    onChange={onChange}
                    value={this.props.selectedDate}
                >
                    {
                        options.map((opt: SelectOption) => (
                            this.buildOption(opt)
                        ))
                    }
                </select>
            </div>
        );
    }

    private buildOption(option: SelectOption): ReactNode {
        return (
            <option
                key={this.props.period + "-" + option.value}
                value={option.value}
            >
                {option.label}
            </option>
        );
    }

    private getSelectOptions(): SelectOption[] {
        const date = moment(this.props.startingDate);
        let options;
        switch (this.props.period) {
            case PeriodSelection.Week:
            case PeriodSelection.Rolling4Weeks:
                options = this.getSelectOptionsWeek(date.startOf("isoWeek"), []);
                break;
            case PeriodSelection.Month:
            case PeriodSelection.RollingQuarter:
            case PeriodSelection.RollingSemester:
            case PeriodSelection.RollingYear:
                options = this.getSelectOptionsMonth(date.startOf("month"), []);
                break;
            case PeriodSelection.Year:
                options = this.getSelectOptionsYear(date.startOf("year"), []);
                break;
            default:
                console.error("PeriodSelection " + this.props.period + " not recognized");
                options = [];
        }
        // Show the options from the most recent.
        return options.reverse();
    }

    private getSelectOptionsWeek(date: Moment, previous: SelectOption[]): SelectOption[] {
        if (moment().isBefore(date)) {
            return previous;
        }
        previous.push({
            value: TimeChanger.format(date),
            label: LOCALE_WEEK + " " + date.isoWeek() + " " + date.isoWeekYear(),
        });
        date.add(1, "week");
        return this.getSelectOptionsWeek(date, previous);
    }

    private getSelectOptionsMonth(date: Moment, previous: SelectOption[]): SelectOption[] {
        if (moment().isBefore(date)) {
            return previous;
        }
        previous.push({
            value: TimeChanger.format(date),
            label: LOCALE_MONTHS[date.month()] + " " + date.year(),
        });
        date.add(1, "month");
        return this.getSelectOptionsMonth(date, previous);
    }

    private getSelectOptionsYear(date: Moment, previous: SelectOption[]): SelectOption[] {
        if (moment().isBefore(date)) {
            return previous;
        }
        previous.push({
            value: TimeChanger.format(date),
            label: "" + date.year(),
        });
        date.add(1, "year");
        return this.getSelectOptionsYear(date, previous);
    }
}
